module.exports = __webpack_public_path__ + "img/PGalley64_ua.0fd5148c.webp";